import useApiClient from './api-client'
import type { TagDetail } from '@/types/api'

export const getTagDetail = async (tagId: number | string) => {
  const api = useApiClient<TagDetail>()
  const result = await api(`/tag/${tagId}`)

  return result
}
